/**
 * Created by jv on 2020-02-07 (12:11).
 */
import utils from "Sources/utils/utils";
import NavUtils from "Sources/utils/navigation-utils";
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/sidenav/sidenav.html";
import Shared from "Sources/shared";

import "Styles/components/sidenav.scss";
import {Promise} from "es6-promise";
import SchoolService from "../services/school-service";
import StorageController from "../controllers/storage-controller";

class SideNav
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.onNavClicked = options.onNavClicked;
    this.hasRendered = false;
    this.profile = Shared.getUserData();
    this.avatarUrl = null;
  }

  get profile()
  {
    return this._profile;
  }

  set profile(profile)
  {
    this._profile = profile;
    this.updateProfile();
  }

  static setUpSideNav(options)
  {
    let instance = new SideNav(options);
    instance.render();
    instance.resetSchools();
    instance.resetAvatar();
    // Reset nav highlight after sidenav has been rendered
    NavUtils.setNavHighlight();
    return instance;
  }

  render()
  {
    this.hasRendered = false;

    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateProfile();

    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  enableMainNav()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.find(".sidenav__main .nav-link").removeClass("disabled");
    }
  }

  disableMainNav()
  {
    // TODO - remove
    if(__DEVELOPMENT__) return;

    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.find(".sidenav__main .nav-link").addClass("disabled");
    }
  }

  //#region schools
  resetSchools()
  {
    this.getSchools().then(schools => {
      this.assignSchools(schools)
    });
  }

  getSchools()
  {
    return new Promise(function(resolve, reject){
      if(StorageController.getFromSession("user-schools") === null)
      {
        SchoolService.getSchools()
          .then(schools => {
            StorageController.saveToSession("user-schools", schools);
            resolve(schools);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get schools");
          });
      }
      else
      {
        let schools = JSON.parse(StorageController.getFromSession("user-schools"));
        resolve(schools);
      }
    });
  }

  assignSchools(schools)
  {
    this.profile.linkedSchools = schools;
    this.updateProfile();
  }
  //#endregion

  resetAvatar() {
    if (this.profile.profilePicture && this.profile.profilePicture.url) {
      this.avatarUrl = this.profile.profilePicture.url;
    }
    else
    {
      Shared.getAllAvatars().then((allAvatars) => {
        if(allAvatars.find(avatar => avatar.key === this.profile.avatar.key))
        {
          this.avatarUrl = allAvatars.find(avatar => avatar.key === this.profile.avatar.key).url;
          this.updateProfile();
        }
        else
        {
          this.avatarUrl = null;
          console.log("avatar not found/set")
        }


      });
    }
    this.updateProfile();
  }

  setUser()
  {
    this.profile = Shared.getUserData();
    this.resetSchools();
    this.resetAvatar();
    this.updateProfile();
  }



  updateProfile()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      let $profileImage = this.$element.find("[data-bind-target='profile-image']");
      $profileImage.empty();

      if(utils.isNotNull(this.profile) && utils.isNotNull(this.avatarUrl))
      {
        $profileImage.append(`<img src=${this.avatarUrl} alt="${LanguageManager.getValueForKey("sidebar.profile.image_alt")}" />`);
      }
      else {
        let imageUrl = require("Images/avatars/avatar_default.png");
        $profileImage.append(`<img src=${imageUrl} alt="${LanguageManager.getValueForKey("sidebar.profile.image_alt")}" draggable="false" />`);
      }

      let $profileName = this.$element.find("[data-bind-target='profile-full-name']");
      $profileName.empty();

      if(utils.isNotNull(this.profile) && utils.isNotNull(this.profile.data))
      {
        $profileName.text(this.profile.data.firstname + " " + this.profile.data.lastname);
      }

      let $profileSchools = this.$element.find("[data-bind-target='profile-linked-schools']");
      $profileSchools.empty();

      if(utils.isNotNull(this.profile) && utils.isNotNull(this.profile.linkedSchools) && this.profile.linkedSchools.length > 0)
      {
        for(let i = 0; i < this.profile.linkedSchools.length; i++)
        {
          $profileSchools.append(`<li>${this.profile.linkedSchools[i].name}</li>`);
        }
      }
      else
      {
        $profileSchools.append(`<li>${LanguageManager.getValueForKey("sidebar.profile.linked_schools.empty")}</li>`)
      }
    }
  }
}

export default SideNav;



// WEBPACK FOOTER //
// ./app/js/components/sidenav.js